"use client";

import { useState } from "react";

export default function CopyableTemplate({
  label,
  content,
}: {
  label: string;
  content: string;
}) {
  const [copied, setCopied] = useState(false);

  const copyTemplate = async () => {
    await navigator.clipboard.writeText(content);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="rounded-xl border border-zinc-200 bg-white p-5">
      <div className="flex items-center justify-between gap-4">
        <span className="text-sm font-semibold text-zinc-700">{label}</span>
        <button
          type="button"
          onClick={copyTemplate}
          className="min-h-10 rounded-lg border border-zinc-300 px-4 py-2 text-sm font-semibold text-zinc-800 transition-colors hover:border-violet-300 hover:text-violet-700"
        >
          {copied ? "Copied" : "Copy template"}
        </button>
      </div>
      <pre className="mt-4 whitespace-pre-wrap font-sans text-base leading-7 text-zinc-700">
        {content}
      </pre>
    </div>
  );
}
